import { render, staticRenderFns } from "./modal-popup-root.vue?vue&type=template&id=4fa35832"
import script from "./modal-popup-root.vue?vue&type=script&lang=ts"
export * from "./modal-popup-root.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports